import NoteTypeCollection from '../../gd-model/note-type/note-type-collection'

const EventNoteTypeReset = function(uid,data) {
    this.data = data;
    this.uid = uid;
};

EventNoteTypeReset.prototype.validate = function(){
    return true;
};

EventNoteTypeReset.prototype.process = function(){
    if (!gd.session._noteTypes) {
        gd.session._noteTypes = new NoteTypeCollection(this.data, {parse:true})
    } else {
        gd.session._noteTypes.resetAndMarkOldModelsAsDeleted(this.data)
    }
};


module.exports = EventNoteTypeReset;